export default __webpack_public_path__ + "static/media/logo-w.c1a7ee73.png";